import LoginForm from '../components/LoginForm';
import MainWrapper from '../components/MainWrapper';
import PostContainer from '../components/Views/DragAndDrop/PostContainer';
import LayOutList from '../components/Views/StructureComponents/LayOutList';
import PostConfig from '../components/Views/StructureComponents/PostConfig';
import Config from '../components/Views/StructureComponents/Config';
import Logout from '../components/Logout';
import EmailTemplateDetail from '../components/Views/EmailsComponents/EmailTemplateDetail';
import EmailTemplateEditor from '../components/Views/EmailsComponents/EmailTemplateEditor';

const routes = [
  {
    path: '/',
    exact: true,
    component: LoginForm,
  },
  {
    path: '/login',
    exact: true,
    component: LoginForm,
  },
  {
    path: '/logout',
    exact: true,
    component: Logout,
  },
  {
    path: '/cms/',
    exact: true,
    component: MainWrapper,
  },
  {
    path: '/cms/:tab',
    exact: true,
    component: MainWrapper,
  },
  {
    path: '/cms/:tab/:postCategory',
    exact: true,
    component: MainWrapper,
  },
  {
    path: '/cms/:tab/:postCategory/choose-layout',
    exact: true,
    component: LayOutList,
  },
  {
    path: '/cms/:tab/:postCategory/:postSubCategory/choose-layout',
    exact: true,
    component: LayOutList,
  },
  {
    path: '/cms/:tab/:postCategory/choose-layout/:layout',
    exact: true,
    component: Config,
  },
  {
    path: '/cms/:tab/:postCategory/:postSubCategory/choose-layout/:layout',
    exact: true,
    component: Config,
  },
  {
    // Literal `emails` on purpose. `/cms/:tab/:postCategory/:slugName` below has the
    // same segment count, and <Switch> takes the first match — without this, the
    // email detail URL renders the Structure post editor. Keeping it literal means
    // it cannot affect any other tab.
    path: '/cms/emails/:scope/:language',
    exact: true,
    component: EmailTemplateDetail,
  },
  {
    // Five segments, so this cannot collide with the 4-segment generic entries
    // below (`/cms/:tab/:postCategory/:slugName` is `exact: true` at 4 segments).
    // The two existing 5-segment routes both require a literal `choose-layout`
    // segment, which this path does not have, so there is no ambiguity there
    // either. Ordered ahead of the generic entries anyway for consistency with
    // the detail route above.
    path: '/cms/emails/:scope/:language/edit',
    exact: true,
    component: EmailTemplateEditor,
  },
  {
    path: '/cms/:tab/:postCategory/:slugName',
    component: PostContainer,
    exact: true,
  },
];

export default routes;
